import React from "react"
import moment from "moment"

class Countdown extends React.Component {
  state = {
    years: undefined,
    months: undefined,
    days: undefined,
    hours: undefined,
    minutes: undefined,
    seconds: undefined,
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      const { toDate, timeFormat } = this.props
      const now = moment()
      const then = moment(toDate, timeFormat)
      let duration = moment.duration(then.diff(now))
      const years = duration.years()
      const months = duration.months()
      const days = duration.days()
      const hours = duration.hours()
      const minutes = duration.minutes()
      const seconds = duration.seconds()
      this.setState({ years, months, days, hours, minutes, seconds })
    }, 1000)
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  render() {
    const { years, months, days, hours, minutes, seconds } = this.state

    return (
      <>
        <div className="countdown-wrapper">
          {years > 0 && (
            <div className="countdown-item years">
              {years}
              <span>&nbsp;{years > 1 ? "years" : "year"}</span>
            </div>
          )}
          {months > 0 && (
            <>
              <div className="countdown-item months">
                {months}
                <span>&nbsp;{months > 1 ? "months" : "month"}</span>
              </div>
              <div className="countdown-item days">
                {days}
                <span>&nbsp;{days > 1 || days == 0 ? "days" : "day"}</span>
              </div>
            </>
          )}
          {months == 0 && days != 0 && (
            <div className="countdown-item days">
              {days}
              <span>&nbsp;{days > 1 || days == 0 ? "days" : "day"}</span>
            </div>
          )}
          {hours >= 0 && (
            <div className="countdown-item hours">
              {hours}
              <span>&nbsp;{hours > 1 || hours == 0 ? "hours" : "hour"}</span>
            </div>
          )}
          {months == 0 && minutes >= 0 && (
            <div className="countdown-item minutes">
              {minutes}
              <span>&nbsp;{minutes > 1 || minutes == 0 ? "minutes" : "minute"}</span>
            </div>
          )}
          {months == 0 && days == 0 && seconds >= 0 && (
            <div className="countdown-item seconds">
              {seconds >= 10 ? seconds : `0${seconds}`}
              <span>&nbsp;{seconds > 1 || seconds == 0 ? "seconds" : "second"}</span>
            </div>
          )}
        </div>
      </>
    )
  }
}

export default Countdown
